module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMS40NDUiIGhlaWdodD0iMjEuNDQ1IiB2aWV3Qm94PSIwIDAgMjEuNDQ1IDIxLjQ0NSI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTt9LmJ7b3BhY2l0eTowLjU0O308L3N0eWxlPjwvZGVmcz48cGF0aCBjbGFzcz0iYSIgZD0iTTAsMEgyMS40NDVWMjEuNDQ1SDBaIi8+PHBhdGggY2xhc3M9ImIiIGQ9Ik02LjYyMSw5LjQ2M2wtNC4wOTItNC4xLDQuMDkyLTQuMUw1LjM2MSwwLDAsNS4zNjFsNS4zNjEsNS4zNjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3LjE0OCA1LjgwOCkiLz48L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./static/ic_keyboard_arrow_left.svg
// module id = 1857
// module chunks = 1